module.exports = __webpack_public_path__ + "static/img/point.cb82c33.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/s28/pop/point.png
// module id = n/nb
// module chunks = 2